import React, {Component} from 'react'
import {reduxForm, Field, change} from 'redux-form'
import DatePickerFormComponent from './redux-form/DatePickerFormComponent'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import { connect } from 'react-redux'
import VirtualizedSelectFormComponent from '../components/redux-form/VirtualizedSelectFormComponent'

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
}

class BackOfficeUserDetailEditMarkForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      allMarkTypes: [],
      filteredMarkTypes: [],
      markRules: {},
      errorFetchingRules: false,
      vehicles: props.mark.Vehicles.map(item => item.id + ''),
      price: {},
      errorFetchingPrice: false,
      error: false,
      selectedTotalPrice: 0
    }

    this.onVehicleChange = this.onVehicleChange.bind(this)
    this.countMarks = this.countMarks.bind(this)
  }

  onVehicleChange (e, index) {
    console.log(e.target.value)
    let newVehicles = [...this.state.vehicles]
    newVehicles[index] = e.target.value
    this.setState({vehicles: newVehicles}, () => this.updatePrice())
  }

  async componentDidMount () {
    try {
      const rules = await SostaOnlineApiService.fetchMarkRulesByMarkType(this.props.markTypeId)
      if (rules.data.length === 0) {
        this.setState({errorFetchingRules: true})
        return
      }

      this.setState({markRules: rules.data[0]}, () => {
        if (this.state.vehicles.filter(item => item !== '').length > 0) {
          this.updatePrice()
        }
      })
    } catch (ex) {
      this.setState({error: true})
    }
  }

  async updatePrice () {
    try {
      const price = await SostaOnlineApiService.fetchMarkPrice(
        this.props.user.id,
        this.props.markTypeId,
        this.props.mark.Category.id,
        this.printVehicles(this.state.vehicles.filter(item => item !== ''))
      )
      if (price.result !== 'ok') {
        this.setState({errorFetchingPrice: true})
        return
      }
      this.setState({price: price.data})
      this.setState({selectedTotalPrice: price.data.price - this.props.mark.price < 0 ? 0 : price.data.price - this.props.mark.price})
      this.props.change('total', price.data.price - this.props.mark.price < 0 ? 0 : price.data.price - this.props.mark.price)
    } catch (ex) {
      this.setState({errorFetchingPrice: true})
    }
  }

  printAreas (areas) {
    let string = ''
    areas.map((item, index) => {
      string = string + item.code

      if (index < areas.length - 1) {
        string = string + ', '
      }
    })
    return string
  }

  printVehicles (vehicles) {
    let string = ''
    vehicles.map((item, index) => {
      string = string + item

      if (index < vehicles.length - 1) {
        string = string + ','
      }
    })
    return string
  }

  countMarks (markTypeId) {
    return this.props.user.marks.filter(item => item.id === markTypeId).length
  }

  render () {
    const {error, handleSubmit} = this.props

    if (this.state.loading) {
      return (<div>Caricamento in corso...</div>)
    }

    if (this.state.error) {
      return (<div className="text-danger">Errore di ricezione dati</div>)
    }

    return (
      <form onSubmit={handleSubmit(values => {
        this.props.onSubmit({
          id: this.props.mark.id,
          price: this.state.price.price - this.props.mark.price,
          ...values,
          vehicles: this.state.vehicles
        })
      })}>
        {this.state.errorFetchingRules && <div className="row">
          <div className="col-12 text-danger">
            Errore nella ricezione delle regole del contrassegno
          </div>
        </div>}

        <div className="form-group">
          <div className="col-md-4 text-left">
            <label>Circolazione</label>
            <Field
              name="circolazione"
              className="form-control"
              component="input"
            />
          </div>
          <div className="col-md-4 text-left">
            <label>Periodo</label>
            <Field
              name="periodo"
              className="form-control"
              component="input"
            />
          </div>
          <div className="col-md-4 text-left">
            <label>Sosta</label>
            <Field
              name="sosta"
              className="form-control"
              component="input"
            />
          </div>
        </div>

        {this.state.markRules.id ? <div className="row form-group">
          <div className="col-md-12 text-left">
              <span
                className={
                  this.state.vehicles.length > this.state.markRules.vehicleLimit
                    ? 'text-danger'
                    : 'text-primary'
                }>
                {this.state.vehicles.length} / {this.state.markRules.vehicleLimit}
              </span>
            {' '}
            <button
              type="button"
              className="btn btn-xs btn-update btn-add-card"
              onClick={() => {
                this.setState(
                  {vehicles: [...this.state.vehicles, '']},
                  () => {
                    this.updatePrice()
                    this.props.dispatch(change('backofficeUserDetailEditMark', `vehicle${this.state.vehicles.length - 1}`, ''))
                  }
                )
              }}>
              Aggiungi Veicolo
            </button>
          </div>
        </div> : null}

        {this.state.markRules.id ? this.state.vehicles.map((item, index) => (
          <div className="row form-group">
            <div className="col-md-12 text-left">
              <label>Seleziona {index + 1}° Veicolo</label>
              <Field
                onChange={(e) => this.onVehicleChange(e, index)}
                name={'vehicle' + index}
                className="form-control"
                component="select"
                required
              >
                {(!this.props.user.vehicles) && <option value={''}>Questo Utente non ha Veicoli</option>}
                {(this.props.user.vehicles && this.props.user.vehicles.length === 0) && <option value={''}>
                  Questo Utente non ha Veicoli
                </option>}
                {(this.props.user.vehicles && this.props.user.vehicles.length > 0) &&
                <option value={''}>Seleziona un veicolo</option>}
                {(this.props.user.vehicles && this.props.user.vehicles.length > 0) &&
                this.props.user.vehicles.map(item =>
                  <option key={item.id} value={item.id}>
                    {item.plate_number + ' - ' + item.VehiclePowerSupply.name}
                  </option>)}
              </Field>
              <button
                onClick={() => this.setState({vehicles: this.state.vehicles.filter((_, i) => i !== index)}, () => this.updatePrice())}
                type="button"
                className="btn btn-xs btn-danger">
                Rimuovi Veicolo
              </button>
            </div>
          </div>
        )) : null}

        {(this.state.markRules.id && this.props.area.indexOf('ZTL') > -1) && <div className="row form-group">
          <div className="col-md-12 text-left">
            <label>Indirizzo di Partenza</label>
            <Field
              name="startAddress"
              options={this.props.addresses.map(item => {
                return {
                  label: item.name,
                  value: item.id
                }
              })} component={VirtualizedSelectFormComponent} required />
          </div>
          <div className="col-md-12 text-left">
            <label>Percorso ZTL</label>
            <Field
              name="addressRoute"
              component="textarea"
              className="form-control"
              required
            />
          </div>
        </div> }

        <div className="row">
          <div className="col-md-6 text-left">
            <label>Prezzo</label>
            <div className="input-group" style={{marginTop: 12, marginBottom: 12}}>
              <div className="input-group-addon">€</div>
              <Field
                name="total"
                component="input"
                type="number"
                className="form-control"
                onChange={e => {
                  if (!e.target.value) {
                    this.setState({selectedTotalPrice: 0})
                    this.props.change('total', 0)
                  } else {
                    this.setState({selectedTotalPrice: e.target.value})
                    this.props.change('total', e.target.value)
                  }
                }}
              />
            </div>
          </div>
        </div>

        {(this.state.selectedTotalPrice > 0) && (
          <div className="row">
            {(this.props.markTypeId) && <div className="col-md-6 text-left">
              <label>Totale</label>
              <div style={{marginTop: 12}}>
                {/*<h4>€ {Number((this.state.price.price - this.props.mark.price) < 0 ? 0 : this.state.price.price - this.props.mark.price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h4> */}
                <h4>€ {Number(this.state.selectedTotalPrice).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h4>
              </div>
            </div>}
          </div>
        )}

        {this.state.selectedTotalPrice > 0 && <div className="row">
          <div className="col-md-6 text-left">
            <label>Metodo di Pagamento</label>
            <div className="radio">
              <label><Field component="input" type="radio" name="method" value="SPORTELLO_POS" required /> POS</label>
            </div>
            <div className="radio">
              <label><Field component="input" type="radio" name="method" value="SPORTELLO_CONTANTI" required /> CONTANTI</label>
            </div>
          </div>
        </div>}

        {/* this.state.selectedTotalPrice === 0 && (
          <div className="text-primary">
            Contrassegno gratuito
          </div>
        ) */}

        <div style={{marginTop: '10px'}}>
          <button onClick={() => this.props.onCancel(this.props.mark)} type="button" className="btn btn-danger btn-xs btn-update btn-add-card">
            Annulla Modifiche
          </button>
          <button type="submit" className="btn btn-xs btn-update btn-add-card">
            Conferma Modifiche
          </button>
        </div>
      </form>
    )
  }
}

BackOfficeUserDetailEditMarkForm = reduxForm({
  form: 'backofficeUserDetailEditMark'
})(BackOfficeUserDetailEditMarkForm)

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserDetailEditMarkForm)



// WEBPACK FOOTER //
// ./src/components/BackOfficeUserDetailEditMarkForm.js